import { z } from 'zod';

/** Search params of the client "סיכומים" tab (TanStack Router validateSearch). Bad values fall back to defaults. */
const str = z
  .union([z.string(), z.number()])
  .transform((v) => String(v))
  .optional()
  .catch(undefined);

export const summariesSearchSchema = z.object({
  kind: z.enum(['daily', 'weekly']).optional().catch(undefined),
  site: str,
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});
export type SummariesSearch = z.infer<typeof summariesSearchSchema>;
